import { render } from "./Footer.vue?vue&type=template&id=768a9a52&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=768a9a52&lang=less&scoped=true"
import "./Footer.vue?vue&type=style&index=1&id=768a9a52&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768a9a52"]])

export default __exports__